export const TABS_TRACKING_LIST: readonly string[] = ["csv enrichment", "crm enrichment"];
export const MODULE = "MY-LISTS";
export const SUB_MODULE = "ENRICHMENT";
export const DD_WIDTH = 320;
export const HINT_WIDTH = "auto";
export const PLACEHOLDER_LOADER_WIDTH = 200;
export const PLACEHOLDER_LOADER_HEIGHT = 15;
export const CSV_LIMIT_VALUE = 100000;
export const ENRICHING_ERROR = "si.my-lists.enrichment.error.state.message";